<template><div><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-bgp-{position}</code> to control where an element's background image is placed.</p>
<code-example custom class="d-d-grid d-g-200 d-g-cols4 d-p-200 d-bgc-secondary" source-code='&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-tl&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgp-tl&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-t&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgp-t&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-tr&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgp-tr&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-r&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgp-r&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-br&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgp-br&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-b&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgp-b&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-bl&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgp-bl&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-l&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgp-l&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-center&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgp-center&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-unset&quot; style=&quot;--bgg-size: 65% 65%; background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgp-unset&lt;/dt-text&gt;
&lt;/dt-stack&gt;'>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-tl" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgp-tl</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-t" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgp-t</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-tr" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgp-tr</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-r" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgp-r</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-br" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgp-br</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-b" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgp-b</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-bl" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgp-bl</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-l" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgp-l</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-center" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgp-center</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var d-bgp-unset" style="--bgg-size: 65% 65%; background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgp-unset</dt-text>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="{ className, output } in positions">
          <th scope="row" class="d-code--sm d-docsite-code">.d-bgp-{{ className }}</th>
          <td class="d-code--sm">
            background-position: {{ output }} !important;
          </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


